/**
 * The giant name closing the home hero (MEETNPLAN) and the footer
 * (MeetNPlan), sized from the screen width so it spans the page at any size.
 * Always set in Latin, even on Arabic pages.
 */
export default function Wordmark({ className = '', ...props }) {
  return (
    <div
      lang="en"
      className={`text-[calc((100vw-80px)/5.5)] leading-none font-extrabold tracking-[-0.03em] whitespace-nowrap ${className}`}
      {...props}
    />
  )
}
